export default "__VITE_ASSET__DT5YRYZp__"